import { Injectable } from '@angular/core';
import { FileOpener } from '@capacitor-community/file-opener';
import { MimeTypeUtils } from 'src/app/common/utilities/MimeTypeUtils';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Device } from '@capacitor/device';
import { Base64BlobUtils } from '../../utilities/Base64BlobUtils';

@Injectable({
  providedIn: 'root'
})
export class FileOpenerService {

  constructor(
  ) { }

  /**
   * Cerca di ritornare il mime type adatto dedotto
   * dall'estensione del file fornito
   * @param fileName
   * @throws error mime type non supportata
   */
  detectMimeTypeFromFileName(fileName: string): string {
    return MimeTypeUtils.detectMimeTypeFromFileName(fileName);
  }

  async openFile(contentB64: string, nomeFile: string, mimeType: string) {
    if (!contentB64 || !mimeType) {
      console.warn('Contenuto del file o mime type vuoti. L\'operazione fallira\'');
      throw new Error('File probably empty or unrecognized mime type');
    }

    const deviceInfo = await Device.getInfo();
    if (deviceInfo.platform.includes('android') || deviceInfo.platform.includes('ios')) {
      console.debug('Apertura file pdf con intent nativo');
      await this.deleteTemporaryFile();
      const tempFileUrl = await this.writeTemporaryFile(nomeFile, contentB64);
      console.debug('File da aprire scritto su filesystem con url ' + tempFileUrl);
      await this.openFileNative(tempFileUrl, mimeType);
    } else {
      const blob = await Base64BlobUtils.base64ToBlob(contentB64, mimeType);
      console.debug('Apertura file in scheda separata browser');
      await this.openBlobFileBrowser(blob, nomeFile);
    }
  }

  private async writeTemporaryFile(fileName: string, contentB64: string): Promise<string> {
    try {
      const fileWrittenEntry = await Filesystem.writeFile({
        path: fileName,
        data: contentB64,
        directory: Directory.Library,
      });
      console.debug(`File ${fileName} generato in  ${Directory.Library}`, fileWrittenEntry.uri);
      return fileWrittenEntry.uri;
    } catch (error) {
      console.error(`Could note create temporary file on  ${Directory.Library}`, error);
      throw error;
    }
  }

  private async deleteTemporaryFile(){
    try {
      const files = await Filesystem.readdir({
        path: ``,
        directory: Directory.Library,
      })

      const fileList = files.files;
      fileList.forEach(async (file) => {
        if(file.type == 'file'){
          const nameFile = file.name;

          await Filesystem.deleteFile({
            path: `${nameFile}`,
            directory: Directory.Library,
          });
          console.debug(`File ${nameFile} eliminato da ${Directory.Library}`);
        }
      });
      
    } catch (error) {
      console.error(`Could not delete temporary files from  ${Directory.Library}`, error);
      throw error;
    }
  }

  /**
   * Dato un blob, apre in una nuova finestra il contenuto lanciando
   * la gestione interna del browser
   * @param blob 
   * @param nomeFile 
   */
  private async openBlobFileBrowser(blob: Blob, nomeFile: string): Promise<void> {
    const fileAsUrl = window.URL.createObjectURL(blob);
    const anchor = window.document.createElement('a'); // Triggero l'apertura del download aprendo la risorsa in un <a>
    anchor.href = fileAsUrl;
    anchor.download = nomeFile;
    anchor.style.visibility = 'hidden';
    document.body.appendChild(anchor);
    window.open(fileAsUrl, '_blank'); //apre in una nuova scheda
    document.body.removeChild(anchor);
    URL.revokeObjectURL(fileAsUrl); // pulisco la memoria
  }

  /**
   * Cerca di aprire il file indicato secondo il mime type 
   * specificato (apre un intent provider e sarà il sistema
   * a decidere come aprire il file)
   * @param fileUrl 
   * @param mimeType stringa del mimeType (es. application/pdf)
   */
  private async openFileNative(fileUrl: string, mimeType: string): Promise<void> {
    try {
      await FileOpener.open({
        filePath: fileUrl,
        contentType: mimeType
      });
    } catch (error) {
      console.error('Impossibile aprire il file ' + fileUrl, error);
    }
  }
}